/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from '../../../core/utils';
import React from 'react';
import { Col } from "react-bootstrap";


export default function Bloc(props) {
  return !props.hide &&(
    <Col lg={6}>
      <header className="header-info">
        <h2>{loc(props.name, {data: props?.data})}</h2>
      </header>
      <div className="hard-shadow-white-block">
        {props.children}
      </div>
    </Col>
  )
}
